import React from 'react'
import { storiesOf } from '@storybook/react'

import Countdown from 'components/Countdown'

storiesOf('Countdown', module)
  .add('> 1 sec', () => (
    <Countdown remainingSec={10} />
  ))
  .add('> 1 min', () => (
    <Countdown remainingSec={70} />
  ))
  .add('> 1 hour', () => (
    <Countdown remainingSec={3610} />
  ))
  .add('> 100 hour', () => (
    <Countdown remainingSec={100 * 3600 + 10} />
  ))
